//  Angular Core
import { Component, inject, OnInit, signal } from '@angular/core';
import { DatePipe } from '@angular/common';

//  UI & Styling
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

//  Internationalization
import { TranslatePipe } from '@ngx-translate/core';

//  Services
import { AuthService } from '../../../core/providers/guards/auth.service';
import { AccessKeyService } from '../access-key.service';

@Component({
  selector: 'app-access-key-modal',
  templateUrl: './access-key-modal.component.html',
  styleUrls: ['./access-key-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltipModule, DatePipe],
})
export class AccessKeyModalComponent implements OnInit {

  // Services and Modal
private activeModal = inject(NgbActiveModal);
private accessKeyService = inject(AccessKeyService);
private auth = inject(AuthService);

//  State Signals
loading = signal(false);
keyCopied = false;

//  Data Signals
data = signal<any | null>(null);
generateAccessKey = signal<any | null>(null);

  
  ngOnInit(): void {
      this.loadAccessKey();
  }
  
  loadAccessKey(): void {
    this.loading.set(true);
    this.accessKeyService.list({}, this.auth.userData?.id)
      .subscribe({
        next: (res: any) => {
          this.data.set(res ?? {});
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        },        
      });
  }

  generateKey(): void {
    this.loading.set(true);
    this.accessKeyService.generate({}, this.auth.userData?.id)
      .subscribe({
        next: (res: any) => {
          this.generateAccessKey.set(res ?? {});
          this.loadAccessKey();
        },
        error: () => {
          this.loading.set(false);
        },
      });
  }

  copyWithTooltip(value: string, tooltip: any): void {
    navigator.clipboard.writeText(value).then(() => {
      this.keyCopied = true;
      // Let Angular update binding before reopening tooltip
      setTimeout(() => {
        tooltip.close();
        tooltip.open();
      });
      setTimeout(() => {
        this.keyCopied = false;
        tooltip.close();
      }, 2000);
    }).catch(() => {
      console.error('Failed to copy key value');
    });
  }

  close(): void {
    this.activeModal.close();
  }

}